import React from "react";
import { useTranslation } from "react-i18next";
import { KycStep } from "../components/KycStep";
import { ReviewProgress } from "../components/ReviewProgress";

export function ProcessingStep({ submitting = false }) {
  const { t } = useTranslation();

  return (
    <KycStep labelledBy="kyc-processing-title" className="kyc-status-step">
      <div className="flex min-h-[42dvh] items-center justify-center py-4">
        <ReviewProgress
          headingAs="h1"
          titleId="kyc-processing-title"
          title={t(
            submitting
              ? "kyc.processing.submittingTitle"
              : "kyc.processing.title",
          )}
          description={t(
            submitting
              ? "kyc.processing.submittingDescription"
              : "kyc.processing.description",
          )}
        />
      </div>
    </KycStep>
  );
}
